import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import makeStyles from '@material-ui/core/styles/makeStyles'
import FamilySvg from 'images/icons/fc-marketing/family.svg'
import GolfHoleSvg from 'images/icons/fc-marketing/golf-hole.svg'
import HatSvg from 'images/icons/fc-marketing/hat.svg'
import Container from 'components/program-marketing/container'
import { HowSectionList } from 'components/program-marketing/how-section-list'

const useStyles = makeStyles(theme => ({
  orange: {
    background: theme.palette.primary.main,
  },
  green: {
    background: theme.palette.secondary.main,
  },
  blue: {
    background: theme.palette.background.dark,
  },
}))

export const HowSection = () => {
  const classes = useStyles()
  const howItWorksListPoints = [
    {
      title: 'Welcoming Environment',
      text:
        'PGA Jr. League believes that every child can be a golfer. From those brand new to the game to more competitive players, all skill levels are invited to learn and play in this welcoming environment.',
      icon: FamilySvg,
      iconBg: classes.orange,
    },
    {
      title: 'Fun Teams',
      text:
        'Teamwork is the heart and soul of PGA Jr. League. Kids play on teams in a scramble format and wear numbered jerseys, supporting and learning from one another to develop skills that translate on and off the course.',
      icon: GolfHoleSvg,
      iconBg: classes.green,
    },
    {
      title: 'Expert Coaching',
      text:
        'PGA Jr. League experiences are led by expert PGA and LPGA Coaches. They’re committed to safety, care and organization, and ultimately helping children learn and enjoy a sport they can play for a lifetime.',
      icon: HatSvg,
      iconBg: classes.blue,
    },
  ]

  return (
    <Container data-testid="how-section">
      <Box mb={2}>
        <Typography variant="h3" color="secondary">
          How it works
        </Typography>
      </Box>
      <Box mb={2}>
        <Typography variant="h2">
          What can I expect from my PGA Jr. League experience?
        </Typography>
      </Box>
      <HowSectionList data={howItWorksListPoints} />
    </Container>
  )
}
